import {useQuery} from '@tanstack/react-query'

import {listEquipmentLocationEvents} from './api'
import {equipmentDeploymentKeys} from './query-keys'

type UseEquipmentLocationEventsOptions = {
    enabled?: boolean
    limit?: number
}

export function useEquipmentLocationEvents(
    assetId: string,
    options?: UseEquipmentLocationEventsOptions,
) {
    const {enabled = true, limit = 20} = options ?? {}

    return useQuery({
        queryKey: equipmentDeploymentKeys.events(assetId, limit),
        queryFn: () => listEquipmentLocationEvents(assetId, {limit}),
        enabled: enabled && Boolean(assetId),
    })
}
